
import { Component, Vue, Ref } from 'vue-property-decorator'
import { EnterpriseService } from '@/services'
import { AppModule } from '@/store/modules/app'
import CompanyDetailForm from './components/company_detail_form.vue'
// eslint-disable-next-line
import AvatarUpload, { AvatarUploadIns } from '@/components/avatar_upload/index.vue'
// eslint-disable-next-line
import DynamicTags, { ins } from '@/components/dynamic_tags/index.vue'
import RowWrap from '@/components/detail/row_wrap/index.vue'
import CreateDetailLayout from '@/layout/edit_layout.vue'
import CompanyCreateForm from './components/company_create_form.vue'
import UploadImg from '@/common/class/UploadImg'

@Component({
    name: 'company-detail',
    components: {
        CompanyDetailForm,
        DynamicTags,
        AvatarUpload,
        RowWrap,
        CreateDetailLayout,
        CompanyCreateForm
    }
})
export default class extends Vue {
    private isUpdateLoading = false
    private keywords: string[] = []
    private stopwords: string[] = [] 
    private bKeywords: string[] = []
    @Ref('formRef') private formEl!: any
    @Ref('keywordRef') private keywordEl!: ins
    @Ref('stopwordRef') private stopwordEl!: ins
    @Ref('bkeywordRef') private bkeywordEl!: ins
    @Ref('avatarRef') private avatarEl!: AvatarUploadIns

    private created() {
        this.$title('创建机构 - 庖丁')
    }

    private async mounted() {
        await AppModule.getIndustry()
    }

    private onCreate() {
        this.formEl.validate(async (company: any) => {
            this.showLoading()
            const keywords = this.keywordEl.getTags()
            const stopwords = this.stopwordEl.getTags()
            const bkeywords = this.bkeywordEl.getTags()
            const imgFile = this.avatarEl.getFile()
            let avatarResult: any
            // 上传图片
            if (imgFile) {
                avatarResult = await new UploadImg(imgFile).upload()
                if (avatarResult.error) {
                    this.$mwarning('图片上传失败')
                    avatarResult = ''
                } else {
                    avatarResult = avatarResult.key
                }
            }
            
            const params = {
                ...company,
                keywords,
                b_keywords: bkeywords,
                stopwords: stopwords,
                logo: avatarResult
            }
            const result = await EnterpriseService.createCompany(params)
            this.hideLoading()
            if (result.status === 200) {
                return this.$msuccess('创建成功')
            }
            this.$merror(result.message || '发生错误, 请稍后再试')
        })
    }

    private showLoading() {
        this.isUpdateLoading = true
    }

    private hideLoading() {
        this.isUpdateLoading = false
    }
}
